export type RealSaving = {
  id: string;
  feature: string;
  vleMobile: string;
  others: string;
  savings: string;
};

const realSavingsThreeGb: RealSaving[] = [
  {
    id: "1",
    feature: "3GB Triple Network Plan",
    vleMobile: "$7/month",
    others: "$20-$30/month",
    savings: "$15-$25/month",
  },
  {
    id: "2",
    feature: "Complete Security Protection",
    vleMobile: "FREE",
    others: "$15/month",
    savings: "$15/month",
  },
  {
    id: "3",
    feature: "International Calling",
    vleMobile: "FREE to 170+ countries",
    others: "$10-$15/month",
    savings: "$10-$15/month",
  },
  {
    id: "4",
    feature: "Global Roaming",
    vleMobile: "FREE in 80+ countries",
    others: "$10/day or $50/month",
    savings: "$50/month",
  },
  {
    id: "5",
    feature: "Total Monthly Savings",
    vleMobile: "",
    others: "",
    savings: "$85-$110+/month",
  },
];

const realSavingsFiveGb: RealSaving[] = [
  {
    id: "1",
    feature: "5GB Triple Network Plan",
    vleMobile: "$9/month",
    others: "$35-$45/month",
    savings: "$26-$36/month",
  },
  {
    id: "2",
    feature: "Complete Security Protection",
    vleMobile: "FREE",
    others: "$15/month",
    savings: "$15/month",
  },
  {
    id: "3",
    feature: "International Calling",
    vleMobile: "FREE to 170+ countries",
    others: "$10-$15/month",
    savings: "$10-$15/month",
  },
  {
    id: "4",
    feature: "Global Roaming",
    vleMobile: "FREE in 80+ countries",
    others: "$10/day or $50/month",
    savings: "$50/month",
  },
  {
    id: "5",
    feature: "Total Monthly Savings",
    vleMobile: "",
    others: "",
    savings: "$91-$101+/month",
  },
];

const realSavingsFifteenGb: RealSaving[] = [
  {
    id: "1",
    feature: "15GB Triple Network Plan",
    vleMobile: "$20/month",
    others: "$45-$55/month",
    savings: "$25-$35/month",
  },
  {
    id: "2",
    feature: "Complete Security Protection",
    vleMobile: "FREE",
    others: "$15/month",
    savings: "$15/month",
  },
  {
    id: "3",
    feature: "International Calling",
    vleMobile: "FREE to 170+ countries",
    others: "$10-$15/month",
    savings: "$10-$15/month",
  },
  {
    id: "4",
    feature: "Global Roaming",
    vleMobile: "FREE in 80+ countries",
    others: "$10/day or $50/month",
    savings: "$50/month",
  },
  {
    id: "5",
    feature: "Total Monthly Savings",
    vleMobile: "",
    others: "",
    savings: "$100-$116+/month",
  },
];

const realSavingsUnlimitedGb: RealSaving[] = [
  {
    id: "1",
    feature: "Unlimited Triple Network Plan",
    vleMobile: "$30/month",
    others: "$60-$80/month",
    savings: "$30-$50/month",
  },
  {
    id: "2",
    feature: "Complete Security Protection",
    vleMobile: "FREE",
    others: "$15/month",
    savings: "$15/month",
  },
  {
    id: "3",
    feature: "International Calling",
    vleMobile: "FREE to 170+ countries",
    others: "$10-$15/month",
    savings: "$10-$15/month",
  },
  {
    id: "4",
    feature: "Global Roaming",
    vleMobile: "FREE in 80+ countries",
    others: "$10/day or $50/month",
    savings: "$50/month",
  },
  {
    id: "5",
    feature: "Total Monthly Savings",
    vleMobile: "",
    others: "",
    savings: "$105-$125+/month",
  },
];

export {
  realSavingsThreeGb,
  realSavingsFiveGb,
  realSavingsFifteenGb,
  realSavingsUnlimitedGb,
};
